import listItem_UpdateCalculatedValues from "./helpers/update-calculated-values"
import ModelProto from "../model-proto"
import ItemsCollection from "./items-collection"
import Project from "../project/project"
import Task from "../task/task"
import Event from "../event/event"
import {SystemStatus} from "../../gd/const/system-status"
import {ModelInterface} from "../../data-structures/collection"
import {EntityType} from "../../gd/const/item"
import {Priority} from "../../gd/types/types"
import Status from "../status/status"
import MapMarker from "../marker/map-marker"
import {Coords} from "google-map-react"
import {FilterItemModel} from "../../manager/filters/manager/@types"
import {ProjectItemOrigin} from "../project-item/@type"
import {ItemDisplay, ListItemCalculatedValues, NumberOfChildren} from "./@type";
import ItemViewAdapter from "./adapters/view"
import {ItemTreeAdapter} from "./adapters/tree"
import {ItemCalculatedValuesAdapter} from "./adapters/calculated"
import CustomFieldsManager from "../../gd/manager/custom-fields-manager"
import SessionCustomField from "../custom-field/session-custom-field"
import {ProjectItem} from "../project-item/project-item"

// const debug = "ItemModel"
const debug = false


export default class ItemModel extends ModelProto implements ModelInterface, FilterItemModel {

    public id!                          : RID

    public isRoot                       : boolean = false   // true if root in our tree
    public treeParent?                  : ItemModel
    public treeChildren                 : ItemModel[]   = []
    public numChildren!                 : NumberOfChildren // recursive ? yes full tree...

    public type                         : EntityType // old values are task | project
    public display                      : ItemDisplay = ItemDisplay.VISIBLE // 0 | 1 | 2         = 1 // 1 - normal, display 2-ghost 0-none // ne pomnu chto tut tipo visible hiddent i ghost parent ?

    public parentId?                    : RID | null = null // is it RID ? this is deprecated but still in use
    public projectItem!                 : ProjectItem // at the moment used for tasks only, used in initTree

    public item!                        : Task | Project | Event
    public childrenItems                : RID[] = [] // ??? do we need it why not treeChildren
    public collection                   : ItemsCollection

    public isCollapsed                  : boolean   = true
    public isSelected                   : boolean   = false // bulk action
    public isFocused                    : boolean   = false // for map(google map?) list

    public costInternal!                : ListItemCalculatedValues
    public costExternal!                : ListItemCalculatedValues
    public estimatedCostInternal!       : ListItemCalculatedValues
    public estimatedCostExternal!       : ListItemCalculatedValues

    public calculatedAttachments!       : ListItemCalculatedValues
    public calculatedStoryPoints!       : ListItemCalculatedValues
    public calculatedExpenses           : ListItemCalculatedValues = { own: 0, children: 0, total : 0}

    public reported!                    : ListItemCalculatedValues // reportedTime
    public estimated!                   : ListItemCalculatedValues // estimate



    public isEmptyProject               : boolean   = false // for Project only

    public displayNumber                : number = 0        // This is table Grid row display number

    public viewSortPosition?            : number                        // currently is used for Task List only for local manual sorting

    // link to rendered component - make sure we alwasy have only 1 (!!!!!!)
    renderComponent?                    : any

    lastUpdateTime                      : number = 0 // used to check component should update

    // added for compatibility with components using ItemModelV2
    public view                         : ItemViewAdapter = new ItemViewAdapter(this)
    public tree                         : ItemTreeAdapter = new ItemTreeAdapter(this)
    public calculated                   : ItemCalculatedValuesAdapter = new ItemCalculatedValuesAdapter(this)

    private _availableCustomFieldsIds?  : ID[]                  // all custom fields available for this item

    constructor(data: any | Task | Project, collection: ItemsCollection) {
        super(data)

        this.collection         = collection
        this.type               = data.type

        let parent : RID | undefined = undefined

        if (data.entityType) {

            // init from resources model...
            switch (data.entityType) {

                case EntityType.TASK:
                    const task = data as Task

                    this.item               = task
                    this.type               = EntityType.TASK
                    this.id                 = task.rid

                    if (this.task.parentTaskId) {
                        parent = "t-" + this.task.parentTaskId
                    } else if (this.task.projectId) {
                        parent = "p-" + this.task.projectId
                    }
                    break

                case EntityType.PROJECT:
                    const project = data as Project
                    this.item   = project
                    this.type   = EntityType.PROJECT
                    this.id     = project.rid

                    if (this.item.parentId) {
                        parent = "p-" + this.item.parentId // parent project ID
                    }
                    break

                default:
                    console.warn("#943874 wtf ?")
            }
        } else {
            // standard init

            switch (this.type) {
                case EntityType.PROJECT:
                    this.item   = new Project(data.item)
                    this.id     = 'p-' + this.item.id

                    if (this.item.parentId) {
                        parent = "p-" + this.item.parentId // parent project ID
                    }
                    break

                case EntityType.TASK:
                    this.item   = new Task(data.item)
                    this.id     = 't-' + this.item.id

                    if (this.task.parentTaskId) {
                        parent = "t-" + this.item.parentTaskId
                    } else if (this.task.projectId) {
                        parent = "p-" + this.task.projectId
                    }

                    break
            }
        }

        this.parentId = parent

        this.updateLastUpdateTime()   //for example for TableRowTask shouldComponentUpdate check
    }

    static initForTask(data: Task | any, collection: ItemsCollection, projectItem: ProjectItem):ItemModel {
        const itemModel = new ItemModel(data, collection)

        itemModel.projectItem = projectItem;

        // we need redefine id
        itemModel.id += '-' + itemModel.projectItem.projectId

        // if (projectItem) {
        //     itemModel.linkedProjectID = projectItem?.projectId || itemModel.task.projectId
        //     itemModel.id += '-' + itemModel.linkedProjectID
        // }

        return itemModel
    }


    marker(defaultAddressFieldId: ID | null): MapMarker | null {

        let address = !!defaultAddressFieldId ? this.item?.customFieldsData[defaultAddressFieldId] : null

        if(address){

            const value = address?.place ? address.place : address

            // Dlya stariy znachenii kotoriy net location poka ustanovlen {latitude: 0, longitude: 0}
            const location: Coords = {
                lat: value?.location?.latitude || 0,
                lng: value?.location?.longitude || 0
            }

            return {
                placeId     : value?.placeId,
                address     : value?.address,
                location    : location
            }
        }

        return null
    }

    get itemType(): EntityType {
        return this.type
    }

    get task():Task {
        return this.item as Task
    }

    get project():Project {
        return this.item as Project
    }

    get event():Event {
        return this.item as Event
    }

    get companyId() {
        return gd.companyId
    }

    get parentProjectId():ID | null {
        switch (this.type) {
            case EntityType.TASK:
                return this.projectItem!.projectId

            case EntityType.PROJECT:
                return this.project.parentId || null

            default:
                throw new Error(`#kdjsnd Unknown entity type ${this.type}`)
        }
    }

    get isMultiProjectTask(): boolean {
        return this.isTask && this.task.isMultiProject
    }

    get isInMainProject(): boolean {
        switch (this.type) {
            case EntityType.TASK:
                return this.projectItem.origin === ProjectItemOrigin.MAIN

            case EntityType.PROJECT:
            case EntityType.EVENT:
            default:
                // no sense for not task items
                return false
        }
    }

    initialize() {
        console.warn("DEPRICATED")
        // this.on('change', this.onDataChanged);
    }

    public updateLastUpdateTime() {
        this.lastUpdateTime = Date.now()
    }

    /*** RENDER COMPONENT ***/

    // link dataItem with current render component (!)
    setRenderComponent(component:any) {
        this.renderComponent = component
    }

    // should be called when we delete or hide (collapse) component in component will unmount
    unsetRenderComponent() {
        this.renderComponent = undefined
    }

    /*** Collapse ***/

    collapse(silent=false) {
        if (this.isCollapsed) return false;
        this.isCollapsed = true;
        if (this.renderComponent && !silent) this.renderComponent.reRender();
    }

    expand(silent=false) {
        if (!this.isCollapsed) return false;
        this.isCollapsed = false;
        if (this.renderComponent && !silent) this.renderComponent.reRender();
    }

    toggleCollapsed(silent=false) {
        // if (this.isCollapsed)
        // ToDo
    }

    get isOpen():boolean {
        return this.item.isOpen
    }

    get isClosed():boolean {
        return this.item.isClosed
    }

    isParent(itemId?: RID):boolean {

        // strange function don't like it get it ...

        if (this.id === itemId) {
            return false
        }


        let res : boolean = false;

        for (let i=0; i < this.childrenItems.length; i++) {
            const child = this.collection.get(this.childrenItems[i])
            if (child) {
                res = child.isParent(itemId);
            }
            // res = this.collection.get(this.childrenItems[i]).isParent(id);
            if (res) break;
        }

        return res;
    }

    get isProject() {
        return this.type === EntityType.PROJECT;
    }

    get isTask() {
        return this.type === EntityType.TASK
    }

    get isEvent() {
        return this.type === EntityType.EVENT
    }

    get isSubTask() {
        return this.type === EntityType.TASK && this.task.isSubtask
    }

    get isHidden() {
        return this.display === ItemDisplay.HIDDEN
    }

    get isVisible() {
        return this.display === ItemDisplay.VISIBLE
    }

    get isNotHidden() {
        return ![ItemDisplay.HIDDEN, ItemDisplay.GHOST_HIDDEN].includes(this.display)
    }

    get availableCustomFieldsIds(): ID[] {
        switch (this.type) {
            case EntityType.TASK:
                if (!this._availableCustomFieldsIds) {
                    const taskAvailableCustomFields = CustomFieldsManager.getTaskViewCustomFields(this.task.taskTypeId, this.task.projectsIds)
                    this._availableCustomFieldsIds  = taskAvailableCustomFields.map((cf: SessionCustomField)=> {
                        return cf.id
                    })
                }
                break

            case EntityType.PROJECT:
                if (!this._availableCustomFieldsIds) {
                    const projectAvailableCustomFields  = CustomFieldsManager.getOrganizationCustomFields(gd.companyId, [gd.const.customFields.scope.PROJECT])
                    this._availableCustomFieldsIds      = projectAvailableCustomFields.map((cf: SessionCustomField) => {
                        return cf.id
                    })
                }
                break

            case EntityType.GROUP:
            case EntityType.EVENT:
            default:
                this._availableCustomFieldsIds = []
                break
        }

        return this._availableCustomFieldsIds
    }

    // is called on task type change or on every project child on custom fields change
    resetAvailableCustomFields() {
        this._availableCustomFieldsIds = undefined
    }

    applyDelta(data:any) {
        const isChanged = this.item.applyDelta(data);

        // item is moved
        if (this.isTask) {
            if (data.taskTypeId) {
                this.resetAvailableCustomFields()
            }

            if (data.projectId) {
                this.parentId = 'p-{0}'.f(data.projectId)
            }
            if (data.hasOwnProperty('parentTaskId')) {
                this.parentId = data.parentTaskId ? 't-{0}'.f(data.parentTaskId) : 'p-{0}'.f(this.task.projectId)
            }
        }

        if (this.isProject) {
            // reset available custom fields on project and every child on custom fields change
            if (data.customFields) {
                this.resetAvailableCustomFields()
                _.map(this.tree.getAllChildren(), (child: ItemModel) => {
                    child.resetAvailableCustomFields()
                })
            }

            if (data.hasOwnProperty('parentId')) {
                this.parentId = data.parentId ? 'p-{0}'.f(data.parentId) : null
            }
        }

        this.updateLastUpdateTime()
        this.updateCalculatedValuesNew()

        if (this.parentId) {
            let currentParent = this.collection.get(this.parentId)
            if (currentParent) currentParent.updateCalculatedValuesNew()
        }

        return isChanged
    }

    update (data:any) {

        switch (this.type){
            case EntityType.PROJECT:
                if (data.id) {
                    this.item.id = data.id;
                    this.id = 'p-'+data.id;
                }

                if (data.projectId) {
                    this.project.parentId = data.projectId;
                    // @ts-ignore
                    this.project.projectId = data.projectId;   // ???? huh
                }
                if (data.priority) this.project.priority = data.priority;
                if (data.sortPosition) this.item.sortPosition = data.sortPosition;

                break;

            case EntityType.TASK:
                if (data.id) {
                    this.item.id = data.id;
                    this.id = 't-'+data.id;
                }

                if (data.shortId) this.task.shortId = data.shortId;
                if (data.parentTaskId) this.task.parentTaskId = data.parentTaskId;
                if (data.projectId) {
                    // if (!data.isTagView) this.task.parentId = data.projectId
                    if (!data.isTagView) {
                        this.task.projectId = data.projectId
                    } else {
                        this.task.projectId = data.projectId;
                    }
                }

                if (data.priority) this.task.priority = data.priority;
                // this.item.progress = data.progress;
                if (data.customFieldsData) this.item.customFieldsData = data.customFieldsData;

                if (data.actionRequiredUserId) this.task.actionRequiredUserId = data.actionRequiredUserId;
                if (data.systemStatus) this.task.systemStatus = data.systemStatus;
                if (data.statusId) this.task.statusId = data.statusId;
                if (data.taskStatusId) this.task.statusId = data.taskStatusId;

                if (data.sortPosition) this.item.sortPosition = data.sortPosition;
                break;
        }
    }
    /*

    /!**
     * Changes the task's projects by moving it from the origin project's group to the target project's group.
     *
     * - Removes this task as a child of the originListItem and adds it as a child of the targetListItem.
     * - Updates this.treeParent to the targetListItem (new project parent).
     * - Clones the originalProjects array to avoid mutating the original.
     * - Removes the project entry corresponding to the originListItem's project.id.
     * - Copies over the 'origin' property from the removed project to the target project entry (if exists), or creates it if missing.
     * - Sets the updated projects array back to the task.
     *
     * @param targetListItem    The ItemModel representing the target project group.
     * @param originListItem    The ItemModel representing the project group being left.
     * @param originalProjects  The original array of project assignments for the task.
     *!/
    changeTaskProjects(
        targetListItem      : ItemModel,
        originListItem      : ItemModel,
        originalProjects    : ProjectItem[]
    ) {
        console.log('!!!changeTaskProjects', targetListItem, originListItem, originalProjects)

        originListItem.removeChildItem(this)
        targetListItem.addChildItem(this)

        this.treeParent = targetListItem
        let newProjects = _.cloneDeep(originalProjects)

        // Remove the project assignment corresponding to the origin group,
        // and grab its 'origin' value for transfer to the target project
        const removed = _.remove(newProjects, (item: ProjectItem) => {
            return item.projectId === originListItem.project.id
        })
        // If there was an 'origin' on the removed project slot, preserve it for the target
        const origin = removed[0].origin

        // Find if the task already has a project assignment for the target project.
        const targetInProjects = _.find(newProjects, (item: ProjectItem) => {
            return item.projectId === targetListItem.project.id
        })

        if (!targetInProjects) {
            // If not yet assigned to the target project: add a new project entry,
            // reusing the origin value from the removed slot.
            newProjects.push({
                origin      : origin,
                projectId   : targetListItem.project.id,
                sortPosition: 0,
            })
        } else {
            // If already in the target project, transfer the origin value.
            targetInProjects.origin = origin
        }

        console.log('!!!changeTaskProjects done', newProjects, _.cloneDeep(this.task.projects))

        this.task.projects = newProjects
    }*/

    changeParent(parentItem?:ItemModel) {

        debug && console.log(debug, "changeParent()")

        if (this.parentId) {
            let currentParent = this.treeParent
            if (currentParent) {
                // currentParent.removeChild(this.id); // old
                currentParent.removeChildItem(this); // new
            }
        }

        if (parentItem){
            // old
            // let newParent = this.collection.get(parentItem.id);
            // if (newParent) newParent.addChild(this.id);

            parentItem.addChildItem(this); // new

            this.parentId   = parentItem.id; // we still need it - nado poiskat' gde i chto
            this.treeParent = parentItem

            switch (parentItem.type) {
                case EntityType.TASK:
                    //this.item.parentId = null;
                    this.task.parentTaskId  = parentItem.task.id;
                    this.task.systemType    = gd.const.taskSystemType.SUBTASK;
                    console.log("a chto esli pomenyalsya i project #4394784")
                    this.isCollapsed        = true; //expand is not allowed for subtasks;
                    break;

                case EntityType.PROJECT:
                    // this.project.parentId = parentItem.item.id;
                    // // @ts-ignore
                    // this.project.projectId = parentItem.item.id;

                    if (this.isTask) {

                        this.task.projectId = parentItem.project.id
                        this.projectItem.projectId = this.task.projectId

                        this.task.parentTaskId = null;
                        this.project.systemType = gd.const.taskSystemType.TASK;
                    }

                    if (this.isProject) {
                        this.project.parentId = parentItem.project.id
                    }
                    break;
            }
        } else {
            //move to root
            this.parentId = null;

            if (this.isProject) {
                // // @ts-ignore
                this.project.parentId = null;
            }


            if (this.isTask){
                this.task.parentTaskId  = null;
                this.task.systemType    = gd.const.taskSystemType.TASK;
            }
        }
    }

    // Deprecated
    removeChild(childId:ID) {
        _.remove(this.childrenItems, (ci) => ci === childId);
        this.updateCalculatedValuesNew();
    }

    // Deprecated
    addChild(childId:RID) {
        this.childrenItems.push(childId);
        this.updateCalculatedValuesNew();
    }

    addChildItem(item:ItemModel) {
        this.childrenItems.push(item.id);
        this.treeChildren.push(item)
        this.updateCalculatedValuesNew();
    }

    removeChildItem(item:ItemModel) {
        _.remove(this.childrenItems, (id:RID) => id === item.id);
        _.remove(this.treeChildren, (iterateItem:ItemModel) => iterateItem.id === item.id);

        this.updateCalculatedValuesNew();
    }

    setStatus(statusId:ID, actionRequiredUserId?:ID) {
        let status : Status = gd.session.statuses.get(statusId)

        switch (this.type){
            case EntityType.PROJECT:

                this.project.systemStatus   = status.systemStatus;
                this.project.statusId       = statusId;


                break;

            case EntityType.TASK:

                this.task.systemStatus      = status.systemStatus;
                this.task.statusId          = statusId;

                if (gd.const.systemStatus.isClosed(this.item.systemStatus))
                    this.task.actionRequiredUserId = null;
                else if (actionRequiredUserId)
                    this.task.actionRequiredUserId = actionRequiredUserId;
                break;

            case EntityType.EVENT:
            default:
                break
        }
    }

    setSystemStatus(status:SystemStatus){
        switch (this.type){
            case EntityType.PROJECT:
                this.project.systemStatus = status;
                break;
        }
    }

    setPriority(priorityValue:Priority, actionRequiredUserId?:ID) {

        if (this.isEvent) return

        switch (this.type) {
            case EntityType.TASK:
                this.task.priority = priorityValue;
                if (actionRequiredUserId) this.task.actionRequiredUserId = actionRequiredUserId;
                break
            case EntityType.PROJECT:
                this.project.priority = priorityValue;
                break
            case EntityType.EVENT:
            default:
                break
        }




    }

    setAR(actionRequiredUserId:ID){
        switch (this.type){
            case EntityType.PROJECT:
                break;

            case EntityType.TASK:
                this.task.setAR(actionRequiredUserId);
                break;
        }
    }

    setAssignedToUser(assignedToUserId:ID) {
        switch (this.type){
            case EntityType.PROJECT:
                break;

            case EntityType.TASK:
                this.task.setAssignedToUser(assignedToUserId);
                break;
        }
    }

    setOwnerUser(ownerUserId:ID) {
        switch (this.type){
            case EntityType.PROJECT:
                // this.project.setOwnerUser(ownerUserId);
                this.project.ownerUserId    = ownerUserId
                break;

            case EntityType.TASK:
                break;
        }
    }

    setProjectManagerUser(managerUserId:ID) {

        console.error("DEPRITCATED #DKDJEDIOE33")

        switch (this.type){
            case EntityType.PROJECT:
                this.project.setProjectManagerUser(managerUserId);
                break;

            case EntityType.TASK:
                break;
        }
    }

    setSortPosition(sortPosition: number, parentProjectId?: ID | null) {
        // this.item.setSortPosition(sortPosition); - old

        switch (this.type){
            case EntityType.PROJECT:
                this.project.sortPosition = sortPosition
                break;

            case EntityType.TASK:
                this.projectItem.sortPosition = sortPosition
                this.task.setProjectSortPosition(this.projectItem.projectId, sortPosition)
                break;
        }
    }

    setStoryPoints(value:number) {
        switch (this.type){
            case EntityType.PROJECT: /*do nothing*/ break;

            case EntityType.TASK:
                // this.task.setStoryPoints(value);
                this.task.storyPoints   = value
                break;
        }
    }

    setIsSelected(val:boolean) {
        this.isSelected = val;
        this.updateLastUpdateTime()
    }

    getIsSelected() {
        return this.isSelected;
    }

    setIsFocused(value: boolean) {
        this.isFocused = value;
        this.updateLastUpdateTime()
    }

    getIsFocused() {
        return this.isFocused;
    }

    isAnyParentSelected() {
        let res = false;

        const _collection = this.collection;
        function collectParent(parentId?:RID|null) {
            if (parentId){
                const parent = _collection.get(parentId);
                if (parent){
                    if (parent.getIsSelected()) res = true;
                    collectParent(parent.parentId);
                }
            }
        }

        collectParent(this.parentId);

        return res;
    }

    updateCalculatedValuesNew() {
        listItem_UpdateCalculatedValues(this)
    }

    countChildrenTasks() {
        if (!this.numChildren) {
            console.warn("#kd787934 - something wrong with num children!")
            return 0
        }

        return this.numChildren.tasks
    }

    get childrenTotal() {
        // calculates closed projects too

        if (!this.numChildren) {
            console.warn("#kdd8934 - something wrong with num children!")
            return 0
        }

        return this.numChildren.tasks + this.numChildren.projects
    }

    countProgressSubItems() {
        let res = 0;

        this.childrenItems.map((childrenId) => {
            let child = this.collection.get(childrenId);
            if (child && gd.const.systemStatus.isClosed(child.item.systemStatus)) res++;
        });

        return res;
    }

    // Old one... feel like we can delete it...
    // countProgressAuto(includeThis = false) {
    //     let res = 0;
    //
    //     if (includeThis && gd.const.systemStatus.isClosed(this.item.systemStatus)) res = 100;   // if this item is closed, then progress is 100%
    //     else if (includeThis && !!this.item.progress) res = this.item.progress;                 // if progress is set then use this value and no children calculation required
    //     else if (this.childrenItems.length > 0) {                                               // otherwise count child items progress
    //         this.childrenItems.map((childrenId) => {
    //             let child = this.collection.get(childrenId);
    //             if (child) {
    //                 res += child.countProgressAuto(true);
    //             }
    //         });
    //         res = gd.utils.roundToDecimals(res/this.childrenItems.length, 2);
    //     }
    //
    //     return res;
    // }

    getAllChildrenIds() {
        const res : any[] = [];
        this.childrenItems.map((childrenId) => {
            const child = this.collection.get(childrenId);
            if (child) {
                res.push(child.id);

                child.getAllChildrenIds().map((cId) => { res.push(cId); });
            }
        });
        return res;
    }

    getAllChildren(openOnly:boolean) {
        let res : any[] = [];
        if (this.childrenItems.length > 0) {
            this.childrenItems.map((childrenId) => {
                const child = this.collection.get(childrenId);
                if (child && (!openOnly || child.isOpen)) {
                    res.push(child);
                    res = res.concat(child.getAllChildren(openOnly));
                }
            });
        }
        return res;
    }

    getAllInvolvedUsersIds():ID[] {
        let res : ID[] = [];

        if (this.isTask) {
            _.map(this.task.users,(user:any)=>{
                res.push(user.userId)
                console.log("456 or user.id ??")
            })
            // res = this.task.users?.map(u=>u.userId);
        }

        this.childrenItems.map((childrenId) => {
            const child = this.collection.get(childrenId);
            if (child) {
                res = res.concat(child.getAllInvolvedUsersIds());
            }
        });

        return res;
    }

    getProjectChildrenLevel(baseLevel = 1) {
        let res = baseLevel;
        if (this.childrenItems.length > 0) {
            let additionalLevel = 0;
            this.childrenItems.map((childrenId) => {
                const child = this.collection.get(childrenId);
                if (child && child.isProject){
                    additionalLevel = child.getProjectChildrenLevel(baseLevel + 1);
                    if (res < additionalLevel) res = additionalLevel;
                }
            });
        }
        return res;
    }

    getProjectChildren() {
        let res : any = [];
        if (this.childrenItems.length > 0) {
            this.childrenItems.map((childrenId) => {
                const child = this.collection.get(childrenId);
                if (child && child.isProject){
                    res.push(child);
                    res = res.concat(child.getProjectChildren());
                }
            });
        }
        return res;
    }

    getAllParents():any[] {
        const res   : any[] = [];

        const _collection = this.collection;

        function collectParent(parentId?:RID|null) {
            if (!parentId) return

            const parent = _collection.get(parentId);
            if (parent){
                res.push(parent);
                collectParent(parent.parentId);
            }
        }

        collectParent(this.parentId);

        return res;
    }

    getName() {
        switch (this.type){
            case EntityType.TASK: return this.task.title;
            case EntityType.PROJECT: return this.item.name;
        }
    }

    getDurationStart():Moment {

        // Gantt has it's own (!!!)
        // this is strage function ...

        let res;
        if (this.isProject && [gd.const.project.type.BACKLOG].includes(this.project.systemType)) {
            const displayStartDate = this.item.displayStartDate
            res = displayStartDate ? displayStartDate : momentDate(); //(Moment().format("YYYY-MM-DD"));
        } else {
            res = this.item.startDate ? this.item.startDate : momentDate(); //Moment(Moment().format("YYYY-MM-DD"));
        }
        return res;
    }


    getTags() {
        console.warn("#409485 tags - use item.task.tags")
        // @ts-ignore
        return this.item.tags
    }

    clone() {

        // used in board for sure (!) maybe somewhere else ...

        const json = this.toJSON()
        // somehow customFieldsData remains referenced so we need to clone it manually
        if (json.item.customFieldsData) json.item.customFieldsData = _.cloneDeep(json.item.customFieldsData)

        return new ItemModel(json, this.collection)
    }

    toJSON() {

        const result : any = {
            id                      : this.id,
            type                    : this.type,

            display                 : this.display,

            parentId                : this.parentId,

            item                    : this.item.toJSON(),
            childrenItems            : this.childrenItems,
            collection               : this.collection,

            isCollapsed              : this.isCollapsed,
            isSelected               : this.isSelected,

            costInternal            : this.costInternal,
            costExternal            : this.costExternal,
            estimatedCostInternal   : this.estimatedCostInternal,
            estimatedCostExternal   : this.estimatedCostExternal,

            reported                : this.reported,
            estimated               : this.estimated,

            numChildren             : _.cloneDeep(this.numChildren),

            isEmptyProject           : this.isEmptyProject,


        //     renderComponent                : this.renderComponent

                lastUpdateTime                  : this.lastUpdateTime



        }


        return result
    }

    debugChildren() {

        let res = ""
        _.map(this.treeChildren, (child)=>{
            res += child.getName() + ", "
        })

        console.log("children=", res)
    }

    get debugName():string {
        switch (this.type){
            case EntityType.TASK    : return "task " + this.task.title
            case EntityType.PROJECT : return "project " + this.item.name
            case EntityType.EVENT   : return "event " + this.item.name
        }

        throw Error("#9487476 unknown type")
    }

}

